<template>
  <svg>
    <use
      :xlink:href="`/static/sprite.svg#icon-${id}`"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    />
  </svg>
</template>

<script>
export default {
  name: 'SVGIcon',
  props: {
    id: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SVGIcon.vue